var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E50B20",
    d: "M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E50B20",
    fillRule: "evenodd",
    d: "M48.61 40.066L34.339 16.324c-.498-.83-1.372-1.324-2.34-1.324-.966 0-1.84.495-2.337 1.322L15.389 40.066c-.506.842-.519 1.895-.035 2.75.481.854 1.391 1.385 2.375 1.385h28.543c.982 0 1.894-.53 2.375-1.386.484-.854.47-1.907-.037-2.75zm-15.8-.732h-1.622c-.447 0-.81-.363-.81-.811V36.9c0-.448.363-.812.81-.812h1.623c.447 0 .81.364.81.812v1.622c0 .448-.363.811-.81.811zM32 32.845c-.896 0-1.623-.727-1.623-1.622v-4.867c0-.896.727-1.622 1.623-1.622.895 0 1.622.726 1.622 1.622v4.867c0 .895-.727 1.622-1.622 1.622z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamation);
export default __webpack_public_path__ + "static/media/icon-exclamation.d6f30409312aa1259f05943f05a2f6a0.svg";
export { ForwardRef as ReactComponent };